var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_98529",
    "data-name": "Group 98529",
    transform: "translate(-148 -177)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_897",
    "data-name": "Ellipse 897",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(148 177)",
    fill: "#f0771f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "auction_2_",
    "data-name": "auction (2)",
    transform: "translate(154 182.91)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98518",
    "data-name": "Group 98518",
    transform: "translate(0 11.715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98517",
    "data-name": "Group 98517",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215594",
    "data-name": "Path 215594",
    d: "M8.682,423.564H8.227A2.07,2.07,0,0,0,6.2,421.91H2.895A2.07,2.07,0,0,0,.87,423.564H.414a.413.413,0,1,0,0,.827H8.682a.413.413,0,1,0,0-.827Z",
    transform: "translate(-0.001 -421.91)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_98520",
    "data-name": "Group 98520",
    transform: "translate(5.846 0.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98519",
    "data-name": "Group 98519",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215595",
    "data-name": "Path 215595",
    d: "M217.053,3.84,213.545.332A.827.827,0,0,0,212.376,1.5l3.508,3.508a.827.827,0,1,0,1.169-1.169Z",
    transform: "translate(-212.134 -0.09)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_98522",
    "data-name": "Group 98522",
    transform: "translate(0 5.936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98521",
    "data-name": "Group 98521"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215596",
    "data-name": "Path 215596",
    d: "M4.919,215.973l-3.508-3.508a.827.827,0,0,0-1.169,1.169l3.508,3.508a.827.827,0,1,0,1.169-1.169Z",
    transform: "translate(0 -212.223)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_98524",
    "data-name": "Group 98524",
    transform: "translate(1.996 2.086)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98523",
    "data-name": "Group 98523",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18552",
    "data-name": "Rectangle 18552",
    width: 4.961,
    height: 4.961,
    transform: "translate(0 3.508) rotate(-45)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_98526",
    "data-name": "Group 98526",
    transform: "translate(11.405 11.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98525",
    "data-name": "Group 98525"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215597",
    "data-name": "Path 215597",
    d: "M416.181,412.566l-.588-.638-1.754,1.754.588.638a1.24,1.24,0,0,0,1.754-1.754Z",
    transform: "translate(-413.839 -411.928)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_98528",
    "data-name": "Group 98528",
    transform: "translate(7.016 7.106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98527",
    "data-name": "Group 98527"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215598",
    "data-name": "Path 215598",
    d: "M257.343,255.678a.815.815,0,0,0-.2-.787.827.827,0,0,0-1.169,0L254.8,256.06a.827.827,0,0,0,0,1.169.815.815,0,0,0,.787.2l2.775,2.72,1.754-1.754Z",
    transform: "translate(-254.559 -254.648)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinked);
export default __webpack_public_path__ + "static/media/linked.5c7e0d5281f749c65c208319aace61f2.svg";
export { ForwardRef as ReactComponent };